import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import { CompletedHeader, OngoingHeader, SubmittedHeader, SavingsHeader, CreatedAssetsHeader } from "../data";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
// import ExportIcon from "../../../assets/icons/exportIcon.svg";
import { TableButton, TableToolbar } from "../../../components/DataTable/DataTable.styles";
import { Select, MenuItem } from "@mui/material";
import ConfirmModal from "../../../components/ConfirmModal";
import { getFilteredTableData } from "../../../utils/Utils";
import { canPerformAction } from "../../../utils/UserAuth";

/* eslint-disable react/prop-types */
const AFDataTable = ({ currentTab, TableData, /*currentFilter, handleFilterChange,*/ handleDeleteAF }) => {
	const [TableHeadCells, setTableHeadCells] = useState(OngoingHeader);
	const [selectedItems, setSelectedItems] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [dateFilter, setDateFilter] = useState("All");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [TableData]);

	useEffect(() => {
		setCurrentTableHeader();
	}, [currentTab]);

	const setCurrentTableHeader = () => {
		let TableHeader = [];
		switch (currentTab) {
			case "ongoing":
				TableHeader = OngoingHeader;
				break;
			case "submitted":
				TableHeader = SubmittedHeader;
				break;
			case "completed":
				TableHeader = CompletedHeader;
				break;
			case "created_assets":
			case "inactive":
			case "active":
			case "funded":
				TableHeader = CreatedAssetsHeader;
				break;
			case "savings":
				TableHeader = SavingsHeader;
				break;
			default:
				TableHeader = OngoingHeader;
		}
		setTableHeadCells(TableHeader);
	};

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, TableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

	const handleDeleteAction = () => {
		console.log("selected", selectedItems);
		setConfirmModal(false);
		handleDeleteAF(selectedItems);
	};

	const AFTableToolbar = ({ selected }) => {
		return (
			<TableToolbar>
				{/* <div className='_notification'>3 new completed deal</div> */}
				<div className='_notification'>{filteredData.length} Item(s) Found</div>

				<div className='_buttons'>
					{/* {currentTab !== "created_assets" && (
						<Select value={currentFilter} className='toolbarSelect' onChange={(e) => handleFilterChange(e)}>
							<MenuItem value='all'>All</MenuItem>
							<MenuItem value='apprentice'>Apprentice</MenuItem>
							<MenuItem value='investor'>Investor</MenuItem>
						</Select>
					)} */}

					<Select value={dateFilter} className='toolbarSelect' onChange={(e) => handleDateFilterChange(e)}>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					{canPerformAction("delete", "apprenticeship") && (
						<TableButton
							variant='outlined'
							color='error'
							onClick={() => {
								setSelectedItems(selected);
								setConfirmModal(true);
							}}>
							<img src={DeleteIcon} alt='' />
						</TableButton>
					)}

					{/* <TableButton variant='outlined' color='primary'>
						<img src={ExportIcon} alt='' />
					</TableButton> */}
				</div>
			</TableToolbar>
		);
	};

	return (
		<>
			<DataTable TableData={filteredData} headCells={TableHeadCells} TableToolbar={AFTableToolbar} />
			{currentTab === "submitted" && (
				<div style={{ fontWeight: 500, fontSize: "14px", marginTop: "1rem", display: "grid", gap: "5px" }}>
					<p>
						<span style={{ color: "red" }}>*</span> <span>One request on finance created by Admin</span>
					</p>
					<p>
						<span style={{ color: "blue" }}>*</span>{" "}
						<span>One request on finance created by Investor(s)</span>
					</p>
					<p>
						<span style={{ color: "red" }}>*2+</span>{" "}
						<span>More than one request on finance created by Admin</span>
					</p>
					<p>
						<span style={{ color: "blue" }}>*2+</span>{" "}
						<span>More than one lease request on finance created by Investor(s)</span>
					</p>
					<p>
						<span style={{ fontWeight: 600 }}>NB: </span>Only one request can be approved for requests with
						the same finance ID
					</p>
				</div>
			)}
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete Apprenticeship Finance",
						desc: "Are you sure you want to delete this AF object(s)?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={handleDeleteAction}
				/>
			)}
		</>
	);
};

export default AFDataTable;
